<template>
    <div class="p-20px pt-42px!">
        <div class="color-#fff text-16px font-900">{{ t('chatSettings.myGems') }}</div>
        <div>
            <div class="flex items-center justify-center">
                <div class="flex bg-#FFFFFF header-round rounded-10 p-6px pl-10px pr-5px" @click="handleAdd">
                    <div class="flex items-center ">
                        <img src="@/assets/images/home/crystal.webp" class="w-20px h-20px mr-5px mt-1px"></img>
                        <div class="text-14px font-500 color-#fff">
                            {{ msgCost }}
                        </div>
                    </div>
                    <img src="@/assets/images/home/add.svg" class="w-20px h-20px ml-5px"></img>
                </div>
            </div>
        </div>
        <div class="color-#fff text-16px font-900 mt-12px">{{ t('chatSettings.title') }}</div>
        <div class="edit-profile p-12px rounded-10px mt-12px" @click="handleEditProfile">
            <div class=" color-#fff flex  items-center">
                <div class="flex items-center justify-center">
                    <img src="@/assets/images/other/edit.svg" alt="" class="w-20px mr-12px">
                </div>
                <div class="flex items-center justify-center text-14px font-500">
                    {{ t('profile.yourName') }}
                </div>
            </div>
        </div>
        <!-- <div class="edit-profile p-12px rounded-10px mt-12px">
            <div class=" color-#fff flex  items-center">
                <div class="flex items-center justify-center">
                    <img src="@/assets/images/message/thinking.svg" alt="" class="w-20px h-20px mr-12px">
                </div>
                <div class="flex items-center justify-center text-14px font-500">
                    {{ t('message.thinking') }}
                </div>
                <div class="w-28px h-12px flex item-centers ml-auto" @click="handleThinking">
                    <img src="@/assets/images/message/check.svg" v-if="!isThinking" class="w-full h-full"></img>
                    <img src="@/assets/images/message/check_on.svg" v-else class="w-full h-full"></img>
                </div>
            </div>
            <div class="text-10px color-#999 pl-33px pt-3px">
                {{ t('chatSettingsRight.innerThoughtDesc') }}
            </div>
        </div> -->

        <div v-if="!isShowFree">
            <div class="mt-12px rounded-10px chat-model p-12px flex items-center justify-between"
                @click="handleShowModel">
                <div class="color-#fff flex items-center">
                    <div>
                        <img src="@/assets/images/other/message.svg" alt="" class="w-20px mr-12px"></img>
                    </div>
                    <div class="text-14px font-500 color-#fff">
                        {{ t('chatSettings.chatModel') }}
                    </div>
                </div>
                <div>
                    <img src="@/assets/images/message/xiala.svg" alt="" class="w-12px mr-12px"></img>
                </div>
            </div>
            <div class="mt-12px rounded-10px chat-model p-12px flex items-center justify-between"
                @click="handleShowChatStyle" v-if="currentStyleList.length>0">
                <div class="color-#fff flex items-center">
                    <div>
                        <img src="@/assets/images/message/style.svg" alt="" class="w-20px mr-12px"></img>
                    </div>
                    <div class="text-14px font-500 color-#fff">
                        {{ t('chatSettings.chatStyle') }}
                    </div>
                </div>
                <div>
                    <img src="@/assets/images/message/xiala.svg" alt="" class="w-12px mr-12px"></img>
                </div>
            </div>
            <div class="mt-12px rounded-10px chat-model p-12px flex items-center justify-between"
            v-if="currentStyleList.length>0"
                @click="handleShowChatPerspective">
                <div class="color-#fff flex items-center">
                    <div>
                        <img src="@/assets/images/message/perspective.svg" alt="" class="w-20px mr-12px"></img>
                    </div>
                    <div class="text-14px font-500 color-#fff">
                        {{ t('chatSettings.chatPerspective') }}
                    </div>
                </div>
                <div>
                    <img src="@/assets/images/message/xiala.svg" alt="" class="w-12px mr-12px"></img>
                </div>
            </div>
            <div class="edit-profile p-12px rounded-10px mt-12px">
                <div class=" color-#fff flex  items-center">
                    <div class="flex items-center justify-center">
                        <img src="@/assets/images/message/next (2).svg" alt="" class="w-20px mr-12px">
                    </div>
                    <div class="flex items-center justify-center text-14px font-500">
                        {{ t('chatSettings.goOnButton') }}
                    </div>
                    <div class="w-28px h-12px flex item-centers ml-auto" @click="handleCheckButton">
                        <img src="@/assets/images/message/check.svg" v-if="!isCheckButton" class="w-full h-full"></img>
                        <img src="@/assets/images/message/check_on.svg" v-else class="w-full h-full"></img>
                    </div>
                </div>
            </div>
        </div>
        <div class="edit-profile p-12px rounded-10px mt-12px flex items-center justify-between" @click="checkBg">
            <div class=" color-#fff flex  items-center">
                <div class="flex items-center justify-center">
                    <img src="@/assets/images/message/photo.svg" alt="" class="w-20px mr-12px">
                </div>
                <div class="flex items-center justify-center text-14px font-500">
                    {{ t('chatSettings.chatBackground') }}
                </div>
            </div>
            <div>
                <img src="@/assets/images/message/xiala.svg" alt="" class="w-12px mr-12px"></img>
            </div>
        </div>
        <!-- <div class="edit-profile p-12px rounded-10px mt-12px">
            <div class=" color-#fff flex  items-center">
                <div class="flex items-center justify-center">
                    <img src="@/assets/images/message/translation_1.svg" alt="" class="w-20px mr-12px">
                </div>
                <div class="flex items-center justify-center text-14px font-500">
                    Auto translation
                </div>
                <div class="w-28px h-12px flex item-centers ml-auto" @click="handleIsAllTranslate">
                    <img v-if="!isAllTranslate" src="@/assets/images/message/check.svg" class="w-full h-full"></img>
                    <img v-else src="@/assets/images/message/check_on.svg" class="w-full h-full"></img>
                </div>
            </div>
        </div> -->
        <div class="edit-profile p-12px rounded-10px mt-12px" @click="handleDelete">
            <div class=" color-#fff flex  items-center">
                <div class="flex items-center justify-center">
                    <img src="@/assets/images/message/delete.svg" alt="" class="w-20px mr-12px">
                </div>
                <div class="flex items-center justify-center text-14px font-500">
                    {{ t('history.deleteHistory') }}
                </div>
            </div>
        </div>
        <div class="edit-profile p-12px rounded-10px mt-12px">
            <div class=" color-#fff flex  items-center">
                <div class="flex items-center justify-center">
                    <img src="@/assets/images/message/tongzhi.svg" alt="" class="w-20px mr-12px">
                </div>
                <div class="flex items-center justify-center text-14px font-500">
                    {{ t('chatSettings.awayMessages') }}
                </div>
                <div class="w-28px h-12px flex item-centers ml-auto" @click="handleAwayMessages">
                    <img v-if="!isAwayMessages" src="@/assets/images/message/check.svg" class="w-full h-full"></img>
                    <img v-else src="@/assets/images/message/check_on.svg" class="w-full h-full"></img>
                </div>
            </div>
        </div>
        <div class="edit-profile p-12px rounded-10px mt-12px" @click="handleReport">
            <div class=" color-#fff flex  items-center">
                <div class="flex items-center justify-center">
                    <img src="@/assets/images/message/report_b.svg" alt="" class="w-20px mr-12px">
                </div>
                <div class="flex items-center justify-center text-14px font-500">
                    {{ t('report.title') }}
                </div>
            </div>
        </div>
        <FirstChargePopUp v-model:showPopup="showPopupFirstCharge" url="/" />
    </div>
</template>

<script setup lang="ts">
import FirstChargePopUp from '@/views/home/com/FirstChargePopUp.vue'
import { useUserStore } from '@/stores/user'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import theme from '@/styles/theme'
import { ref, onMounted, watch } from 'vue'
import { MessageAPI } from '@/services/message'
import { showSuccessToast, showLoadingToast } from '@/utils/toast'
import { useDialog } from '@/composables/useDialog'
import { UserInfoAPI } from '@/services/user'
import { isFreeRole } from '@/utils/publicMethod'
import { logEventSafe } from '@/plugins/firebase'
import { useI18n } from 'vue-i18n'
import { useRandomArrayStore } from '@/stores/useRandomArrayStore'
import CryptoJS from 'crypto-js'
import { getFirst32 } from '@/utils/aesCrypto'
const dialog = useDialog()
const { t } = useI18n()
const showPopupFirstCharge = ref(false)
const randomStore = useRandomArrayStore()
const props = defineProps<{
    info: any
    handleIsAllTranslate: () => void
    isAllTranslate: any
    handleDelete: () => void
    handleReport: () => void
    checkBg: () => void
    handleShowStorePopup: () => void
    hanldeClose: () => void
    handleThinkingToast: () => void
    showModel: () => void
    showChatStyle: () => void
    showChatPerspective: () => void
    isShowFree: boolean
    modelList: any
}>()

const router = useRouter()
const userStore = useUserStore()
const msgCost = computed(() => userStore.msgCost)
const activeNames = ref<string[]>([])
const active = ref(0)
const isCheckButton = computed(() => userStore.isCheckButton)
const isAwayMessages = computed(() => userStore.userInfo.noticeSwitch)
const infoData = computed(() => userStore.getTouristInfo())
const isEmbeddedH5 = computed(() => userStore.getIsEmbeddedH5())
const maxValue = ref(0)
const isThinking = ref()


// 组件挂载时同步 localStorage 的值到 store
onMounted(() => {
    userStore.getCeckButton()
})

const handleAdd = () => {
    props.handleShowStorePopup()
}

const handleEditProfile = () => {
    router.push({ name: 'EditProfile' })
}

const modelList = ref<any[]>([])
const getModelList = async () => {
    const res = await MessageAPI.modelList({})
    modelList.value = res.data
    let a = Math.max(...modelList.value.map(item => item.cost))
    maxValue.value = a
    setThinkingToast()
    localStorage.setItem('modelIndex', String(modelList.value.find((item: any) => item.isChecked === true)?.id))
}

/**
 * 开启继续说
*/
const handleCheckButton = () => {
    userStore.setCheckButton()
}

/**
 * 开启思考
*/
const handleThinking = () => {
    if (isThinking.value) {
        isThinking.value = 0
    } else {
        let item = modelList.value.filter(item => item.isChecked === true)
        if (item.length > 0) {
            if (item[0].isThinking) {
                isThinking.value = 1
            } else {
                props.handleThinkingToast()
            }
        } else {
            props.handleThinkingToast()
        }
    }
}

/**
 * 离开消息
*/
const handleAwayMessages = async () => {

    if (isAwayMessages.value) {

        const confirmed = await dialog.confirm({
            title: t('awayMessages.disableAwayMessages'),
            message: t('awayMessages.disableConfirm', { appName: isEmbeddedH5.value ? 'CandyGF' : 'CoupleU' }),
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel'),
            confirmButtonColor: '#667eea'
        })
        if (confirmed) {
            showLoadingToast(t('common.loading'))
            let noticeSwitch = 0
            if (isAwayMessages.value === 0) {
                noticeSwitch = 1
            } else {
                noticeSwitch = 0
            }
            await UserInfoAPI.updateUserProfile({
                noticeSwitch: noticeSwitch,
            })
            await userStore.getUserInfo()
            userStore.getTouristInfo()
            showSuccessToast(t('success.switchSuccess'))
        }
    } else {
        showLoadingToast(t('common.loading'))
        let noticeSwitch = 0
        if (isAwayMessages.value === 0) {
            noticeSwitch = 1
        } else {
            noticeSwitch = 0
        }
        await UserInfoAPI.updateUserProfile({
            noticeSwitch: noticeSwitch,
        })
        await userStore.getUserInfo()
        userStore.getTouristInfo()
        showSuccessToast(t('success.switchSuccess'))
    }

}

// 展示模型

const handleShowModel = () => {
    props.showModel()
}

// 展示聊天风格
const handleShowChatStyle = () => {
    // 文风功能点击埋点
    logEventSafe('chatstyle_click')
    props.showChatStyle()
}
// 展示聊天视角
const handleShowChatPerspective = () => {
    logEventSafe('chatper_click')
    props.showChatPerspective()
}
const setThinkingToast = () => {

    isThinking.value = modelList.value.find(item => item.isChecked === true)?.isThinking
}


// 获取当前选中的模型
const styleList = computed<any[]>(() =>
    (props.modelList || []).filter((item: any) => item.isChecked)
)

// 获取当前模型的样式列表
const currentStyleList = computed(() => {
    const list = styleList.value[0]?.more?.LiteraryStyle || []
    // 确保返回的是响应式数组
    return [...list]
})

// 监听 currentStyleList 变化，设置默认选中
watch(currentStyleList, (newList) => {
    if (newList.length > 0) {
        // 检查是否已经有选中的项
        const hasSelected = newList.some(item => item.isSelected)

        // 如果没有选中的项，默认选中第一个
        if (!hasSelected) {
            // 使用 setTimeout 确保在下一次 DOM 更新时设置
            setTimeout(() => {
                newList[0].isSelected = true
            }, 0)
        }
    }
}, { immediate: true })

onMounted(() => {
    //支付结果
    // window[randomStore.randomArray[0]] = (e: any) => {
    //     const bytes = CryptoJS.AES.decrypt(e, getFirst32('8e7351e-10cfda-aichat-cherry-ai-ios'))
    //     const json = bytes.toString(CryptoJS.enc.Utf8)
    //     if (JSON.parse(json)[randomStore.randomArray[0]]) {
    //         showPopupFirstCharge.value = false
    //     }
    // }
    // active.value = Number(localStorage.getItem('modelIndex')) || 0
    getModelList()
    // setThinkingToast()
})
</script>
<style scoped lang="scss">
.header-round {
    margin-top: 12px;
    padding: 12px;
    width: 100%;
    background: rgba(255, 255, 255, 0.1);
    justify-content: space-between;
    border-radius: 10px;
}

.edit-profile {
    background-color: v-bind('theme.colors.backgroundQuinary');
}

.chat-model {
    background-color: v-bind('theme.colors.backgroundQuinary');
}

:deep(.van-collapse::after) {
    border: none !important;

}

:deep(.van-cell) {
    // border-radius: 10px 5px 15px 0 !important;
}

:deep(.van-cell::after) {
    border: none !important;
}

:deep(.van-collapse-item__content) {
    background-color: v-bind('theme.colors.backgroundQuaternary');
}

:deep(.van-collapse-item__wrapper) {
    // background-color: v-bind('theme.colors.backgroundQuaternary');
}

.model-box {
    margin-left: 10px;
    background-color: v-bind('theme.colors.backgroundQuaternary');
    border-radius: 6px;
    padding: 10px;
    border: 1px solid transparent;

    &.active {
        border: 1px solid #7284F7;
        background: rgba(114, 132, 247, 0.1);
    }

    &.ishot {
        border: 1px solid #EE0772;
        background: rgba(244, 147, 253, 0.1) !important;
    }

    &.isCostSee {
        background: linear-gradient(90deg, #353750 0%, #323C4E 100%);
    }
}

.cost {
    background: rgba(171, 182, 255, 0.1);
}

.thinking {
    background: rgba(53, 55, 80, 1);
    border-radius: 12px;
    padding: 2px 5px;
}

::v-deep(.van-cell) {
    padding: 12px !important;
    // border-radius: 10px !important;
}

.model-text {
    color: v-bind('theme.colors.textSecondary') !important;
}
</style>
